import { useState, useEffect } from 'react';
import axios, { AxiosError } from 'axios';

interface UserProfile {
  name: string;
  imageUrl: string;
  //TODO: Add any other user profile properties if the need arises
}

const useUserProfile = (): [UserProfile, boolean, Error | null] => {
  const [userProfile, setUserProfile] = useState<UserProfile>({
    name: 'Guest User',
    imageUrl: 'https://via.placeholder.com/150',
  });
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        //TODO: Replace this with actual API call to fetch the user's profile
        const response = await axios.get('/api/user-profile');
        setUserProfile(response.data);
        setIsLoading(false);
      } catch (err) {
        const axiosError = err as AxiosError;
        if (axiosError.response?.status === 404) {
          // using the fallback user profile if the endpoint is not found
          setIsLoading(false);
        } else {
          setError(axiosError as Error);
          setIsLoading(false);
        }
      }
    };

    fetchUserProfile();
  }, []);

  return [userProfile, isLoading, error];
};

export default useUserProfile;
